import { PaymentUrl } from "../interface/payment"

export class InitPaymentSessionException extends Error { }

export const initPaymentSession = (amount: number, orderId?: string): Promise<PaymentUrl> => {
    const url = `/api/payment/order?amount=${amount}&order_id=${orderId}`;
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    }).then((response) => {
        if (response.ok) {
            return response.json()
        }
        throw new InitPaymentSessionException()
    }).catch(() => { throw new InitPaymentSessionException() })
}